/* eslint flowtype/no-types-missing-file-annotation: 0 */

// DEPRECATED

import ledgerAccountCategoryTypes from './ledgerAccountCategoryTypes';
import ledgerAccountOrderingTypes from './ledgerAccountOrderingTypes';
import sidebarTypes from './sidebarTypes';

export type BenchClient = {
  id: string;
  // ... other properties
  featureFlags: Feature;
};

export type Feature = {
  [key: string]: boolean;
};

export type ClientComment = {
  id: string;
  body: string;
  createdOn: string;
};

export type InternalNote = {
  id: string;
  body: string;
  createdOn: string;
  flagged: boolean;
};

export type AddOn = {
  id: string;
  name: string;
};

export type Document = {
  id: string;
  name: string;
  date: Date;
};

export type JournalEntry = {
  id: string;
  addOn?: AddOn;
  categorization?: TransactionCategorization;
  clientCatLedger?: LedgerAccount;
  clientCatResponse?: string;
  categorizerMethod?: string;
  categorizerLedgerId?: string;
  clientComments: Array<ClientComment>;
  dataEntries: Array<DataEntry>;
  dateOfTransaction: string;
  document?: Document;
  internalNotes: Array<InternalNote>;
  transferId: string;
  vendorName: string;
  relatedJE: { id: string };
  contractorId?: string;
  source1099?: string;
};

export type SuggestedLedger = {
  id: string;
  ledgerAccount: LedgerAccount;
};

type TransactionCategorization = {
  id: string;
  clientResponse: string;
  selectedLedgerAccountId: string;
  selectedLedgerName: string;
  suggestedLedgers: Array<SuggestedLedger>;
};

export type DataEntry = {
  id: string;
  amountInCents: number;
  hasPotentialQualityIssues: boolean;
  journalEntry: JournalEntry;
  ledgerAccount?: LedgerAccount;
  task?: {
    id: string;
    status: string;
    createdOn?: string;
    createdBy?: string;
    resolvedOn?: string;
  };
};

export type JournalEntryConnection = {
  edges: Array<{ node: JournalEntry }>;
};

export type FinancialInstitution = {
  id: string;
  name: string;
};

export type FinancialInstitutionProductType = {
  id: string;
  name: string;
};

export type FinancialInstitutionProduct = {
  id: string;
  financialInstitution: FinancialInstitution;
  financialInstitutionProductType: FinancialInstitutionProductType;
};

export type LedgerAccount = {
  id: string;
  category?: LedgerAccountCategory;
  code: string;
  dataEntries: Array<DataEntry>;
  details: string;
  internalNotes: Array<InternalNote>;
  name: string;
  role?: string;
  openingBalanceInCents?: number;
  closingBalanceInCents?: number;
  sumTotalInCents?: number;
  isPeerReviewed?: boolean;
  isResolved?: boolean;
  accountLastFourDigits?: string;
  financialInstitutionProduct?: FinancialInstitutionProduct;
};

export type LedgerAccountWithJournalEntries = LedgerAccount & {
  journalEntries: JournalEntryConnection;
};

export type LedgerAccountCategory = {
  id: string;
  ledgerAccounts: Array<LedgerAccount>;
  ledgerAccountCategoryType: keyof typeof ledgerAccountCategoryTypes;
  ledgerCategoryOrderingType: keyof typeof ledgerAccountOrderingTypes;
  name: string;
  order: number;
};

export type GeneralLedgerListItem = {
  key: any;
  // A React component with a `getHeight` function that takes the same props as the component and
  // returns its estimated height in pixels, used for rendering it in the main page body
  ItemComponent: any;
  // The props passed to the ItemComponent for rendering it in the main page body
  itemProps: Record<string, unknown>;
  // A React component that renders this item in the navigation sidebar
  NavComponent?: any;
  // The props passed to the NavComponent for rendering it in the navigation sidebar
  navProps?: Record<string, unknown>;
};

export type DateRange = {
  endDate?: string;
  startDate?: string;
};

export type SidebarDescriptor = {
  sidebarElementId: string;
  sidebarType: keyof typeof sidebarTypes;
};

export type TaskStatusFilter = 'none' | 'all' | 'pending' | 'confirmed';

export type GeneralLedgerFilters = {
  search?: string;
  showAccounts?: boolean;
  showQualityIssues?: boolean;
  taskStatusFilter?: TaskStatusFilter;
};

export type AggregateBalance = {
  id: string;
  ledgerAccounts: LedgerAccountWithJournalEntries;
  closingBalanceCents: number;
  openingBalanceCents: number;
  inPeriodBalanceCents: number;
  inPeriodDataEntries: number;
};

export type AggregateBalanceSummaries = Array<AggregateBalance>;

export type Contractor = {
  id: string;
  name: string;
};

export type FeatureFlags = {
  report1099: boolean;
};

export type Client = {
  id: string;
  company: string;
  countryCode: string;
  featureFlags: FeatureFlags;
};

export type DataEntryRowProps = {
  dataEntry: DataEntry;
  hasBackgroundColor: number;
  index: number;
  isAccount?: boolean;
  isSelected?: boolean;
  search?: string;
  isMoneyInTransitOutstanding: boolean;
  filterMito: boolean;
  showCategorizationSuggestions?: boolean;
  showLedgerAccountName?: boolean;
  toggleDataEntry: (entry: DataEntry) => void;
  client?: Client;
  matchingAmountTransactions?: DataEntry[];
  moneyInTransitLedgerId?: string;
  showSourceColumn?: boolean;
  showTasksColumn?: boolean;
};
